import { ref } from 'vue'
function filterErrors(errors, basepath, excludeChildren = false) {
	return (errors || [])
		.map((error) => {
			const matcher = excludeChildren ? new RegExp(`^${basepath}$`) : new RegExp(`^${basepath}\\.*`)
			if (error.path.match(matcher)) {
				return { ...error, path: error.path.replace(matcher, '') }
			}
		})
		.filter((error) => !!error)
}

export default function () {
	const errors = ref({})

	return {
		setErrors: (inputErrors = []) => {
			const finalErrors = {}
			inputErrors.forEach(({ path }) => {
				finalErrors[path] = filterErrors(inputErrors, path)
			})
			errors.value = finalErrors
		},
		errors,
		clearError: (field) => {
			delete errors.value[field]
		}
	}
}
